export const isActive = 'is-active';
export const isShow = 'is-show';
export const isHide = 'is-hide';
export const isOpen = 'is-open';
export const isClose = 'is-close';
export const isLocked = 'is-locked';
export const isFixed = 'is-fixed';
export const breakpointSM = 767;
export const breakpointMD = 1069;
export const breakpointLG = 1300;